import { Pipe, PipeTransform } from '@angular/core';

import { ComponentData } from '../models/component-data';
import { TabData } from '../models/tab-data';
import { ComponentDataSelectorUtil } from '../utils/component-data-selector.util';

@Pipe({
	name: 'tabSelector'
})
export class TabSelectorPipe implements PipeTransform {
	public transform(componentData: ComponentData, tabIds: string[], matchingType: string = 'string'): TabData[] {
		return ComponentDataSelectorUtil.tabSelector(componentData, tabIds, matchingType);
	}
}
